import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { editorUrl} from 'utils/url';

export const EDITOR_FETCH_DATA_INIT = createAction('EDITOR_FETCH_DATA_INIT');
export const EDITOR_FETCH_DATA_SUCCESS = createAction('EDITOR_FETCH_DATA_SUCCESS');
export const EDITOR_FETCH_DATA_FAIL = createAction('EDITOR_FETCH_DATA_FAIL');

export const EDITOR_FETCH_SHAPE_INIT = createAction('EDITOR_FETCH_SHAPE_INIT');
export const EDITOR_FETCH_SHAPE_SUCCESS = createAction(
  'EDITOR_FETCH_SHAPE_SUCCESS'
);
export const EDITOR_FETCH_SHAPE_FAIL = createAction('EDITOR_FETCH_SHAPE_FAIL');

export const EDITOR_CLEAR_DATA = createAction('EDITOR_CLEAR_DATA');


function  createShapeLookup(shapeData) {
  const shapeLookupMap = new Map();

  if (!Array.isArray(shapeData)) {
    console.warn("Input shapeData is not an array. Returning empty map.");
    return shapeLookupMap;
  }

  for (const shape of shapeData) {
    // Ensure shape and its properties exist before trying to use them
    if (shape && typeof shape === 'object') {
      if (shape._id) {
        // Store the shape object using its ID as the key
        shapeLookupMap.set(shape._id, shape);
      }
      if (shape.name) {
        // Store the *same* shape object using its name as the key
        // It's good practice to normalize the name (e.g., to lowercase) for case-insensitive matching
        shapeLookupMap.set(shape.name, shape);
      }
      // Optional: If you anticipate duplicate names/IDs and need specific conflict resolution,
      // you might store an array of shapes instead of a single shape.
      // For now, it assumes IDs are unique and names should map to a single preferred shape if duplicates exist.
    }
  }
  return shapeLookupMap;
}
export const fetchEditorData = ({
  siteId,
}) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(EDITOR_FETCH_DATA_INIT());

    console.log('fetch shape')

    if (siteId) {
      let editors;
      try {
        editors = await Axios.get(`${editorUrl}/site/open-parsed/${siteId}`, {
          withCredentials: false,
        });
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(EDITOR_FETCH_DATA_FAIL({ error }));
      }
      const shapes = editors.data.data.freeShapes;
      const model3ds = editors.data.data.model3ds;
      const shapeLookUp = createShapeLookup([...shapes,...model3ds]);

      return dispatch(
        EDITOR_FETCH_DATA_SUCCESS({
          shapes: shapeLookUp,
          shapeList: shapes,
          model3ds: model3ds,
        })
      );
    }
  };
};


export const clearEditorData = () => {
  return (dispatch) => {
    dispatch(EDITOR_CLEAR_DATA());
  };
};

